import { LaravelResponse, keyToUrl } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { IContactAttributeResource } from "../types";

export const contactAttributeKeys = {
	index: ["contact-attributes"],
};

export const contactAttributeUrls = {
	index: keyToUrl(contactAttributeKeys.index),
};

const index = () => axios.get<LaravelResponse<IContactAttributeResource[]>>(contactAttributeUrls.index);

export const contactAttributeService = {
	index,
};

const initialContactAttributes: IContactAttributeResource[] = [];

export const useContactAttributesQuery = () => {
	const { data, isLoading } = useQuery({
		queryKey: contactAttributeKeys.index,
		queryFn: () => contactAttributeService.index().then((r) => r.data.data),
	});

	return {
		contactAttributes: data ?? initialContactAttributes,
		isLoading,
	};
};
